import { render, staticRenderFns } from "./TableEvents.vue?vue&type=template&id=106296c0&scoped=true&"
import script from "./TableEvents.vue?vue&type=script&lang=js&"
export * from "./TableEvents.vue?vue&type=script&lang=js&"
import style0 from "./TableEvents.vue?vue&type=style&index=0&id=106296c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106296c0",
  null
  
)

export default component.exports